export default __webpack_public_path__ + "static/media/silver.95989466.svg";